// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-family: 'Georgia', serif;
  font-size: 14px;
}

.editor {
  cursor: text;
  font-size: 16px;
}

:global(.text-align--center .public-DraftStyleDefault-ltr) {
  text-align: center;
}

:global(.text-align--right .public-DraftStyleDefault-ltr) {
  text-align: right;
}

:global(.text-align--justify .public-DraftStyleDefault-ltr) {
  text-align: justify;
}

.editor :global(.public-DraftEditorPlaceholder-root),
.editor :global(.public-DraftEditor-content) {
  margin: 0;
  /* 1px is added as transparent border on .DraftEditor-editorContainer */
  padding: 9px;
}

.editor :global(.public-DraftEditor-content) {
  overflow: auto;
}

.hidePlaceholder :global(.public-DraftEditorPlaceholder-root) {
  display: none;
}

.editor .paragraph {
  margin: 14px 0;
}

/* Consecutive code blocks are nested inside a single parent <pre> (like <li>
  inside <ul>). Unstyle the parent and style the children. */
.editor pre {
  margin: 14px 0;
}

.editor .codeBlock {
  background-color: #f3f3f3;
  font-family: "Inconsolata", "Menlo", "Consolas", monospace;
  font-size: 16px;
  /* This should collapse with the margin around the parent <pre>. */
  margin: 14px 0;
  padding: 20px;
}

/* Hacky: Remove padding from inline <code> within code block. */
.editor .codeBlock span[style] {
  padding: 0 !important;
}

.editor .blockquote {
  border-left: 5px solid #eee;
  color: #666;
  font-family: 'Hoefler Text', 'Georgia', serif;
  font-style: italic;
  margin: 16px 0;
  padding: 10px 20px;
}

/* There shouldn't be margin outside the first/last blocks */
.editor .block:first-child,
.editor pre:first-child,
.editor ul:first-child,
.editor ol:first-child {
  margin-top: 0;
}
.editor .block:last-child,
.editor pre:last-child,
.editor ul:last-child,
.editor ol:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-rte/lib/RichTextEditor.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,uEAAuE;EACvE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;4DAC4D;AAC5D;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0DAA0D;EAC1D,eAAe;EACf,kEAAkE;EAClE,cAAc;EACd,aAAa;AACf;;AAEA,gEAAgE;AAChE;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;;;;EAIE,aAAa;AACf;AACA;;;;EAIE,gBAAgB;AAClB","sourcesContent":[".root {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-family: 'Georgia', serif;\n  font-size: 14px;\n}\n\n.editor {\n  cursor: text;\n  font-size: 16px;\n}\n\n:global(.text-align--center .public-DraftStyleDefault-ltr) {\n  text-align: center;\n}\n\n:global(.text-align--right .public-DraftStyleDefault-ltr) {\n  text-align: right;\n}\n\n:global(.text-align--justify .public-DraftStyleDefault-ltr) {\n  text-align: justify;\n}\n\n.editor :global(.public-DraftEditorPlaceholder-root),\n.editor :global(.public-DraftEditor-content) {\n  margin: 0;\n  /* 1px is added as transparent border on .DraftEditor-editorContainer */\n  padding: 9px;\n}\n\n.editor :global(.public-DraftEditor-content) {\n  overflow: auto;\n}\n\n.hidePlaceholder :global(.public-DraftEditorPlaceholder-root) {\n  display: none;\n}\n\n.editor .paragraph {\n  margin: 14px 0;\n}\n\n/* Consecutive code blocks are nested inside a single parent <pre> (like <li>\n  inside <ul>). Unstyle the parent and style the children. */\n.editor pre {\n  margin: 14px 0;\n}\n\n.editor .codeBlock {\n  background-color: #f3f3f3;\n  font-family: \"Inconsolata\", \"Menlo\", \"Consolas\", monospace;\n  font-size: 16px;\n  /* This should collapse with the margin around the parent <pre>. */\n  margin: 14px 0;\n  padding: 20px;\n}\n\n/* Hacky: Remove padding from inline <code> within code block. */\n.editor .codeBlock span[style] {\n  padding: 0 !important;\n}\n\n.editor .blockquote {\n  border-left: 5px solid #eee;\n  color: #666;\n  font-family: 'Hoefler Text', 'Georgia', serif;\n  font-style: italic;\n  margin: 16px 0;\n  padding: 10px 20px;\n}\n\n/* There shouldn't be margin outside the first/last blocks */\n.editor .block:first-child,\n.editor pre:first-child,\n.editor ul:first-child,\n.editor ol:first-child {\n  margin-top: 0;\n}\n.editor .block:last-child,\n.editor pre:last-child,\n.editor ul:last-child,\n.editor ol:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
